$(document).ready(function () {
            const addEventListeners = () => {
                $('header nav details').each(function () {
                    const $details = $(this);
                    const $summary = $details.find('summary');
                    const $megaMenuContent = $details.find('.mega-menu__content');

                    $details.hover(
                        function () {
                            if ($(window).width() > 750) {
                                $details.attr('open', true);
                                $summary.attr('aria-expanded', 'true');
                            }
                        },
                        function () {
                            if ($(window).width() > 750) {
                                $details.removeAttr('open');
                                $summary.attr('aria-expanded', 'false');
                            }
                        }
                    );

                    $megaMenuContent.hover(
                        function () {
                            if ($(window).width() > 750) {
                                $summary.attr('aria-expanded', 'true');
                            }
                        },
                        function () {
                            if ($(window).width() > 750 && !$details.attr('open')) {
                                $summary.attr('aria-expanded', 'false');
                            }
                        }
                    );
                });
            };

            const removeEventListeners = () => {
                $('header details').off('mouseenter mouseleave');
                $('.mega-menu__content').off('mouseenter mouseleave');
                $('header details summary').attr('aria-expanded', 'false');
            };

            const handleResize = () => {
                if ($(window).width() > 750) {
                    addEventListeners();
                } else {
                    removeEventListeners();
                }
            };

            $(window).resize(handleResize);
            handleResize();  // Initial check
        });

$(document).ready(function(){
     $('.slides_img').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: true,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'ease-in-out',
            touchThreshold: 100
    });
    $('.ib-running-bar').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                  {
                   breakpoint: 768,
                   settings: {
                         slidesToShow: 1,
                         slidesToScroll: 1,
                     autoplay: true,
            autoplaySpeed: 3000,
                    }
               }
           ]
      
    });
    $('.ib-sh-fea-col-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            arrows:true,
            slidesToShow: 5,
            slidesToScroll: 1,
          responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                      breakpoint: 700,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1               
                      }
                  }
                ]
        });
  });

  $(document).ready(function() {
  $('.ib-mob-menu li').click(function(event) {
    event.stopPropagation();
    $(this).children('ul').slideToggle();
    $(this).toggleClass('ib-active');
    $(this).siblings().removeClass('ib-active').children('ul').slideUp();
  });
});

$(document).ready(function() {
  $('.mega-menu__link').each(function() {
    var content = $(this).html();
    if (content.includes('&lt;br&gt;')) {
      $(this).html(content.replace(/&lt;br&gt;/gi, ''));
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ib-mob-menu a br').forEach(br => br.remove());
});

document.addEventListener('DOMContentLoaded', function() {
    const headerIcon = document.querySelector('.header__icon');
    const menuDrawer = document.getElementById('menu-drawer');
    const closeIcon = document.querySelector('.ibat-closediv-menu');
    const detailsMenuDrawerContainer = document.getElementById('Details-menu-drawer-container');
    const bodyElement = document.body;

    headerIcon.addEventListener('click', function() {
        if (menuDrawer.style.display === 'block') {
            menuDrawer.style.display = 'none';
        } else {
            menuDrawer.style.display = 'block';
        }
    });
  
  closeIcon.addEventListener('click', function() {
        detailsMenuDrawerContainer.removeAttribute('open');
        bodyElement.classList.remove('overflow-hidden-tablet');
        if (menuDrawer.style.display === 'block') {
            menuDrawer.style.display = 'none';
        } else {
            menuDrawer.style.display = 'block';
        }
    });
});


$(document).ready(function() {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 150) {
            $('nav.header__inline-menu').addClass('ib-header-fixed');
        } else {
            $('nav.header__inline-menu').removeClass('ib-header-fixed');
        }
    });
});



// Search temporary JS---------------------

$(document).ready(function() {
    $(".ib-row.row-3 details-modal.header__search form").click(function(event) {
        var searchInput = $("header.header .ib-row.row-3 .search__input");
            searchInput.css("visibility", "visible");
    });
});

// color patch js

$(document).ready(function() {
    if (!$('.ib-product-div li.ibat-color-patch-img').length && !$('.ib-product-div li.ibat-length-variant').length) {
        $('.ibat-your-selection').hide();
    }
});

//need lenght and gram related
$(document).ready(function() {
    var isEventBound = false;

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if ($('.fancybox-stage').length > 0) {             
                if (!isEventBound) {
                    
                    $(document).on('click', '.fancybox-stage', function(event) {
                        // Check if the click event target is exactly .fancybox-stage
                        if (event.target === this) {
                            $('.fancybox-close-small').click();
                        }
                    });

                    isEventBound = true; // Set the flag to true
                }

                observer.disconnect();
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
});


//Updating number of products in cart without page load js

$(document).ready(function() {
    let previousCartCount = $('.cart-count').text() || '0';

    function updateDynamicCount() {
        let currentCartCount = $('.cart-count').text().trim();
        if (currentCartCount === '') {
            currentCartCount = '0';
        }
        
        if (currentCartCount !== previousCartCount) {
            $('.ib-dynamic-count').text(currentCartCount);
            previousCartCount = currentCartCount;
        }
    }

    setTimeout(updateDynamicCount, 500);

    // Function to setup the MutationObserver
    function setupObserver() {
        const targetNode = document.querySelector('.cart-count');
        if (targetNode) {
          
            const config = { childList: true, characterData: true, subtree: true };

            const callback = function(mutationsList) {
                for (let mutation of mutationsList) {
                    console.log("Mutation detected:", mutation); // Debug log
                    if (mutation.type === 'childList' || mutation.type === 'characterData' || mutation.type === 'attributes') {
                        updateDynamicCount();
                    }
                }
            };

            const observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }
        else {
            setTimeout(setupObserver, 1000);
        }
    }


    setTimeout(setupObserver, 1000); 

});





